module.exports = __webpack_public_path__ + "static/media/WhatsappLogo-Photoroom.d00ec7a2.png";